"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var BlockListConflictResolver_1 = __importStar(require("./BlockListConflictResolver"));
var Model_1 = __importDefault(require("../../Browser/Model"));
var IsBlockBrowser_1 = require("../IsBlockBrowser");
var mobx_1 = require("mobx");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var OperationsChannel_1 = require("Common/OperationsChannel/OperationsChannel");
var BlockListController = (function () {
    function BlockListController(make, project, user, $http, apiBaseUrl, notifyUser, $timeout, OperationsChannel, usingFeature, projectStore) {
        var e_1, _a;
        var _this = this;
        this.make = make;
        this.project = project;
        this.user = user;
        this.$http = $http;
        this.apiBaseUrl = apiBaseUrl;
        this.notifyUser = notifyUser;
        this.$timeout = $timeout;
        this.usingFeature = usingFeature;
        this.projectStore = projectStore;
        this.allBlocks = {};
        this._inProgressOperations = [];
        this.getIndex = function (block) {
            return (0, mobx_1.computed)(function () {
                return lodash_1.default.findIndex(_this._blockList, { $id: block.$id });
            }).get();
        };
        this.getBlockAtIndex = function (index) {
            if (index == null) {
                throw new Error("No index given for getting a block");
            }
            else if (index >= _this.getLength() || index < 0) {
                throw new Error("Trying to retrieve a block at a non-existent index");
            }
            else {
                return _this.project.blocks[index];
            }
        };
        this.getBlockWithId = function (blockId) {
            if (blockId == null) {
                throw new Error("No id given for getting a block");
            }
            var block = lodash_1.default.find(_this.project.blocks, { _id: blockId });
            if (block == null) {
                throw new Error("Trying to retrieve a block with unknown id");
            }
            else {
                return block;
            }
        };
        this.getFirstBlockOfType = function (blockType) {
            return lodash_1.default.find(_this.project.blocks, { type: blockType }) || null;
        };
        this.getLength = function () {
            return _this._blockList.length;
        };
        this.removeBlock = function (removeBlock, fromCollab) {
            var _a;
            if (fromCollab === void 0) { fromCollab = false; }
            _this.runBlockListModification(function (blocks) {
                lodash_1.default.remove(blocks, removeBlock);
            });
            delete _this.allBlocks[removeBlock._id];
            if (!(0, IsBlockBrowser_1.isBlockBrowser)(removeBlock) && !fromCollab) {
                _this.$http.delete("".concat(_this.apiBaseUrl, "/projects/").concat(_this.project._id, "/blocks/").concat(removeBlock._id));
                var markAcceptEnabled = _this.make.get("markAcceptEnabled");
                markAcceptEnabled();
                if (["QuoteV2", "Quote"].includes(removeBlock.type)) {
                    _this.projectStore.decrementQuoteBlockCount();
                    if (!_this.usingFeature(FeatureFlag_1.default.MultipleCurrencies)) {
                        _this.projectStore.updateManualPageValueCurrency((_a = removeBlock.settings) === null || _a === void 0 ? void 0 : _a.currency);
                    }
                }
                if (_this.project.blocks.length === 0 && !_this.usingFeature(FeatureFlag_1.default.Sidebar)) {
                    _this.createBlockBrowserAfter();
                }
                var action_1 = _this.createAction(BlockListConflictResolver_1.BlockMoveAction.Remove, removeBlock._id);
                return _this.operationsChannel.sendOperation(action_1);
            }
        };
        this.createBlockBrowserAfter = function (block, scrollFlag) {
            if (block === void 0) { block = null; }
            if (scrollFlag === void 0) { scrollFlag = ""; }
            var index;
            if (block === null) {
                index = 0;
            }
            else {
                index = _this.getIndex(block) + 1;
                block.$blockBrowserOpen = true;
            }
            var model = lodash_1.default.cloneDeep(Model_1.default);
            model.$scrollTo = scrollFlag !== "no-scroll-to";
            model.cssBlockName = "block-browser-new";
            _this.runBlockListModification(function (blocks) {
                blocks.splice(index, 0, model);
            });
        };
        this.replaceBlock = function (blockModel, replaceBlock) {
            var initialIndex = Math.max(_this.getIndex(replaceBlock), 0);
            replaceBlock.$loading = true;
            var blockPermission = blockModel.$userAction;
            delete blockModel.$userAction;
            return _this.create(blockModel, initialIndex)
                .then(function (response) {
                (0, mobx_1.runInAction)(function () {
                    var block = response.data;
                    block.$userAction = blockPermission;
                    _this.allBlocks[block._id] = block;
                    var afterCreationIndex = Math.max(_this.getIndex(replaceBlock), 0);
                    _this.removeBlock(replaceBlock);
                    _this.addBlock(block, afterCreationIndex);
                });
                _this.$timeout(function () {
                    (0, mobx_1.runInAction)(function () {
                        var lastBlock = lodash_1.default.last(_this.project.blocks);
                        if (!(0, IsBlockBrowser_1.isBlockBrowser)(lastBlock)) {
                            return _this.createBlockBrowserAfter(lastBlock, "no-scroll-to");
                        }
                    });
                });
            })
                .catch(function () {
                replaceBlock.$loading = false;
                return _this.notifyUser.error("There was an error creating that block.");
            });
        };
        this.insertBlockAtIndex = function (blockModel, insertionIndex, _a) {
            var _b = _a === void 0 ? {} : _a, _c = _b.insertDelayMs, insertDelayMs = _c === void 0 ? 0 : _c, _d = _b.skipScrolling, skipScrolling = _d === void 0 ? false : _d;
            return __awaiter(_this, void 0, Promise, function () {
                var blockPermission, operation, request, _e, response, block;
                return __generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            blockPermission = blockModel.$userAction;
                            delete blockModel.$userAction;
                            if (blockModel.clonedFrom) {
                                operation = { type: "clone", clonedFromId: blockModel.clonedFrom };
                                this.addInProgressOperation(operation);
                            }
                            request = this.create(blockModel, insertionIndex);
                            return [4, Promise.all([request, (0, utils_1.delay)(insertDelayMs)])];
                        case 1:
                            _e = __read.apply(void 0, [_f.sent(), 1]), response = _e[0];
                            block = response.data;
                            block.$userAction = blockPermission;
                            if (operation) {
                                this.removeInProgressOperation(operation);
                            }
                            this.addBlock(block, insertionIndex, { skipScrolling: skipScrolling });
                            return [2];
                    }
                });
            });
        };
        this.create = function (blockModel, blockPosition) {
            blockModel.projectId = _this.project._id;
            blockModel.createdBy = _this.user._id;
            if (blockPosition != null) {
                blockModel.blockPosition = blockPosition;
            }
            return _this.$http.post("".concat(_this.apiBaseUrl, "/projects/").concat(_this.project._id, "/blocks"), blockModel);
        };
        this.addBlock = function (block, atIndex, options) {
            if (atIndex === void 0) { atIndex = 0; }
            if (options === void 0) { options = {}; }
            var skipPersistance = options.skipPersistance, skipScrolling = options.skipScrolling;
            if (!(0, IsBlockBrowser_1.isBlockBrowser)(block) && !skipScrolling) {
                block.$scrollTo = true;
            }
            _this.allBlocks[block._id] = block;
            _this.runBlockListModification(function (blocks) {
                blocks.splice(atIndex, 0, block);
            });
            if (!skipPersistance && !(0, IsBlockBrowser_1.isBlockBrowser)(block)) {
                var action_2 = _this.createAction(BlockListConflictResolver_1.BlockMoveAction.Insert, block._id);
                _this.operationsChannel.sendOperation(action_2);
            }
        };
        this.moveUp = function (block) { return __awaiter(_this, void 0, Promise, function () {
            var index, removedBlocks, action;
            return __generator(this, function (_a) {
                index = this.getIndex(block);
                if (index <= 0 || index >= this.project.blocks.length) {
                    return [2];
                }
                this.runBlockListModification(function (blocks) {
                    removedBlocks = blocks.splice(index, 1);
                    blocks.splice(index - 1, 0, removedBlocks[0]);
                });
                action = this.createAction(BlockListConflictResolver_1.BlockMoveAction.Up, removedBlocks[0]._id);
                return [2, this.operationsChannel.sendOperation(action)];
            });
        }); };
        this.moveDown = function (block) { return __awaiter(_this, void 0, Promise, function () {
            var index, outOfBound, removedBlocks, action;
            return __generator(this, function (_a) {
                index = this.getIndex(block);
                outOfBound = index < 0 || index >= this.project.blocks.length - 1;
                if (outOfBound) {
                    return [2];
                }
                this.runBlockListModification(function (blocks) {
                    removedBlocks = blocks.splice(index, 1);
                    blocks.splice(index + 1, 0, removedBlocks[0]);
                });
                action = this.createAction(BlockListConflictResolver_1.BlockMoveAction.Down, removedBlocks[0]._id);
                return [2, this.operationsChannel.sendOperation(action)];
            });
        }); };
        this.refreshOrder = function (newVersion, newOrder) {
            var e_2, _a;
            var block;
            var idx;
            if (newVersion <= _this.operationsChannel.getVersion()) {
                return;
            }
            else {
                _this.operationsChannel.updateVersion(newVersion);
            }
            var newBlockOrder = [];
            try {
                for (var newOrder_1 = __values(newOrder), newOrder_1_1 = newOrder_1.next(); !newOrder_1_1.done; newOrder_1_1 = newOrder_1.next()) {
                    var blockId = newOrder_1_1.value;
                    block = _this.allBlocks[blockId];
                    if (block != null) {
                        newBlockOrder.push(block);
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (newOrder_1_1 && !newOrder_1_1.done && (_a = newOrder_1.return)) _a.call(newOrder_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            for (idx = 0; idx < _this.project.blocks.length; idx++) {
                block = _this.project.blocks[idx];
                if ((0, IsBlockBrowser_1.isBlockBrowser)(block)) {
                    newBlockOrder.splice(idx, 0, block);
                }
            }
            for (idx = 0; idx < newBlockOrder.length; idx++) {
                block = newBlockOrder[idx];
                _this.runBlockListModification(function (blockList) {
                    blockList[idx] = block;
                });
            }
            _this.runBlockListModification(function (blockList) {
                blockList.splice(newBlockOrder.length, blockList.length - newBlockOrder.length);
            });
        };
        this.toIds = function (blocks) {
            var filtered = lodash_1.default.filter(blocks, function (block) {
                return (0, IsBlockBrowser_1.isBlockBrowser)(block) === false;
            });
            return filtered.map(function (block) { return block._id; });
        };
        this.createAction = function (actionName, blockId) {
            var position = lodash_1.default.findIndex(_this.project.blocks, { _id: blockId });
            var basicAction = {
                payload: _this.toIds(_this.project.blocks),
                move: {
                    blockId: blockId,
                    action: actionName,
                    context: {
                        position: position,
                    },
                },
            };
            if (actionName === BlockListConflictResolver_1.BlockMoveAction.Remove) {
                return basicAction;
            }
            basicAction.move.context.between = {};
            if (position !== 0) {
                var firstPosition = position - 1;
                while (firstPosition >= 0 && (0, IsBlockBrowser_1.isBlockBrowser)(_this.project.blocks[firstPosition])) {
                    firstPosition--;
                }
                if (firstPosition >= 0) {
                    basicAction.move.context.between.first = _this.project.blocks[firstPosition]._id;
                }
            }
            if (position !== _this.project.blocks.length - 1) {
                var secondPosition = _this.getNextNonBrowserBlockIndex(position);
                if (secondPosition > 0) {
                    basicAction.move.context.between.second = _this.project.blocks[secondPosition]._id;
                }
            }
            return basicAction;
        };
        this.getNextNonBrowserBlockIndex = function (startingPosition) {
            var position = startingPosition + 1;
            while (position < _this.project.blocks.length && (0, IsBlockBrowser_1.isBlockBrowser)(_this.project.blocks[position])) {
                position++;
            }
            if (position >= _this.project.blocks.length) {
                return -1;
            }
            else {
                return position;
            }
        };
        this.runBlockListModification = function (modificationFunc) {
            modificationFunc(_this._angularBlockList);
            modificationFunc(_this._blockList);
        };
        this.addInProgressOperation = function (operation) {
            _this._inProgressOperations.push(operation);
        };
        this.removeInProgressOperation = function (operation) {
            _this._inProgressOperations.splice(_this._inProgressOperations.indexOf(operation), 1);
        };
        this.isOperationInProgress = function (operation) {
            return (0, mobx_1.computed)(function () { return _this._inProgressOperations.findIndex(function (op) { return lodash_1.default.isEqual(op, operation); }) >= 0; }).get();
        };
        var conflictResolver = (0, BlockListConflictResolver_1.default)(this.refreshOrder);
        this.operationsChannel = this.make(OperationsChannel, {
            endpoint: "".concat(this.apiBaseUrl, "/projects/").concat(this.project._id, "/sort-order"),
            startingPersistVersion: this.project.persistVersion || 0,
            conflictResolver: conflictResolver,
            onFinishedProcessing: function () { },
            onError: function (errorMsg) {
                return _this.notifyUser.error(errorMsg);
            },
            onRetry: function (errorMsg) {
                return _this.notifyUser.warn(errorMsg);
            },
            processMode: OperationsChannel_1.QueueProcessMode.FastForward,
        });
        try {
            for (var _b = __values(this.project.blocks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var block = _c.value;
                this.allBlocks[block._id] = block;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this._blockList = this.project.blocks;
        this._angularBlockList = this.project.blocks;
    }
    Object.defineProperty(BlockListController.prototype, "blocks", {
        get: function () {
            return this._blockList;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable.shallow,
        __metadata("design:type", Array)
    ], BlockListController.prototype, "_blockList", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], BlockListController.prototype, "_inProgressOperations", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], BlockListController.prototype, "blocks", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockListController.prototype, "removeBlock", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockListController.prototype, "createBlockBrowserAfter", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockListController.prototype, "replaceBlock", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockListController.prototype, "insertBlockAtIndex", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockListController.prototype, "addBlock", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockListController.prototype, "moveUp", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockListController.prototype, "moveDown", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockListController.prototype, "refreshOrder", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockListController.prototype, "runBlockListModification", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockListController.prototype, "addInProgressOperation", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockListController.prototype, "removeInProgressOperation", void 0);
    return BlockListController;
}());
exports.default = BlockListController;
